module.exports = __webpack_public_path__ + "static/media/youth.e705f4ea.png";